import React from 'react'
import PropTypes from 'prop-types'

export const METable = props => {
  let columnCss = props.columnCss ? props.columnCss : {}
    return (
      <table className="table table-striped table-hover table-condensed">
        <thead>
          <tr>
            {props.columns.map((col, i) => (
              <th
                key={i}
                className={columnCss[col] !== undefined ? columnCss[col] : null}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.data.map((row, i) => (
            <tr key={`${i}`}>
              {row.map((cell, j) => (
                <td key={`${i}_${j}`}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

METable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
}
